module.exports = __webpack_public_path__ + "img/Icon_evaluation_process.721c48e7.svg";